import { ApiModel } from '@core/models';

export function formatMultiStoreData<T extends ApiModel>(items: T[]): { [k: string]: T } {
  const itemsFormatted: { [k: string]: T } = {};
  items.forEach((item) => {
    itemsFormatted[item.id] = item;
  });
  return itemsFormatted;
}
